import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import useTimeZoneList from '../../utilities/useTimeZoneList';
import SelectField, { type SelectFieldProps } from './SelectField';

export type TimeZoneSelectFieldProps = Omit<SelectFieldProps, 'options' | 'children'>;

const TimeZoneSelectField = (props: TimeZoneSelectFieldProps) => {
    const { loading, data } = useTimeZoneList();

    // format timezone with offset
    const options = useMemo(
        () => data.map(item => ({ label: `${item} (UTC${dayjs().tz(item).format('Z')})`, value: item })),
        [data]
    );

    return <SelectField {...props} loading={loading} options={options} required />;
};

export default TimeZoneSelectField;
